import {z} from '@hono/zod-openapi';

export const supplierPartsSearchRequestSchema = z
  .object({
    catalogNumber: z.string().trim().min(2).max(100).optional(),
    namePattern: z.string().trim().min(2).max(100).optional(),
    priceListCode: z.enum(['HONDA_CZ', 'NISSAN_CZ']).optional(),
    manufacturerId: z.string().uuid().optional(),
    supplierId: z.string().uuid().optional(),
    supplierIds: z.array(z.string().uuid()).max(100).optional(),
    manufacturerIds: z.array(z.string().uuid()).max(100).optional(),
    branchId: z.string().uuid(),
    authorizationProfileId: z.string().uuid(),
    supplierAccountCode: z.string().max(100).optional(),
    // Older Metada warehouse flows serialize an unselected order type as null.
    // Treat it the same as an omitted selection so those flows retain the
    // catalog's native order-type behavior.
    supplierOrderTypeCode: z.string().max(100).nullish(),
    searchType: z.enum(['EQUALS', 'LIKE', 'STARTS_WITH', 'ENDS_WITH']).default('LIKE'),
    normalized: z.boolean().optional(),
    activeOnly: z.boolean().optional(),
    expandOrderTypes: z.boolean().optional(),
    limit: z.number().int().min(1).max(100).optional(),
    offset: z.number().int().min(0).max(50000).optional(),
  })
  .strict()
  .openapi('SupplierPartsSearchRequest');
export type SupplierPartsSearchRequest = z.infer<typeof supplierPartsSearchRequestSchema>;
